import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { PropertyAttributeComponent } from '@rma/public/campaigns/public/ui-campaign-attribute';
import { PropertyStatusComponent } from '@rma/public/campaigns/public/ui-status';
import { ListingImageType } from '@rma/public/generic/domain/types';
import { provideRmaCarousel, RmaCarouselComponent, RmaCarouselItemSource } from '@rma/public/generic/ui/carousel';
import { MarketReportCampaign, MarketReportTransactionType } from '../../domain';

@Component({
  selector: 'rma-market-report-comparable-property',
  templateUrl: './market-report-comparable-property.component.html',
  styleUrls: ['./market-report-comparable-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CurrencyPipe,
    DatePipe,
    PropertyAttributeComponent,
    PropertyStatusComponent,
    RmaCarouselComponent,
    TranslocoDirective,
    TranslocoPipe,
  ],
  providers: [provideRmaCarousel()],
})
export class MarketReportComparablePropertyComponent implements OnChanges {
  @Input()
  campaign: MarketReportCampaign | null | undefined;

  @HostBinding('class.bg-blue-10')
  @Input()
  selected = false;

  @HostBinding()
  public readonly class = 'rounded-b shadow-lg flex flex-col h-full print:flex-row print:shadow-none print:mb-3';

  public marketReportTransactionTypeEnum = MarketReportTransactionType;

  images: RmaCarouselItemSource[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const { campaign } = changes;

    if (campaign) {
      this.images = this.campaign ? this.getImages(this.campaign) : [];
    }
  }

  private getImages(campaign: MarketReportCampaign): RmaCarouselItemSource[] {
    const alt = campaign.streetAddress;

    if (campaign.propertyImages) {
      return [
        ...campaign.propertyImages.filter((x) => x.imageType === ListingImageType.Hero),
        ...campaign.propertyImages.filter((x) => x.imageType !== ListingImageType.Hero),
      ].map((x) => ({ src: x.imageUrl, alt }));
    }
    return [];
  }
}
